import amplitude from "./local-site/amplitude";
import { getCookieConsent, getAmplitudeApiKey, shouldSendToAmplitude } from './helpers';

//create new instance of amplitude js object for interacting with the Amplitude browser SDK
window.amplitude = new amplitude();
//get amplitude key
let amplitudeApiKey = getAmplitudeApiKey() || [];
//loop to control whether amplitude events are sent
let loopCount = 1;
let cookieLoop = setInterval(function() {
        if (loopCount >= 15) {
            clearInterval(cookieLoop);
        }
        loopCount++;
        let cookieConsent = getCookieConsent();
        if (cookieConsent === 'true' || cookieConsent === 'false') {
            clearInterval(cookieLoop);
            processAmplitudeInit(cookieConsent);
        }
    }, 1000);

function processAmplitudeInit(cookieConsent) {
let optOut;
let disableCookies;

switch(shouldSendToAmplitude(cookieConsent)) {
    case true:
        disableCookies = false;
        optOut = false;
        window.amplitude.initialiseAmplitude(amplitudeApiKey, disableCookies, optOut);
        break;
    case false:
        disableCookies = true;
        optOut = true;
        window.amplitude.initialiseAmplitude(amplitudeApiKey, disableCookies, optOut);
        break;
  }
}
// event for homepage slider interaction event
$("#cta-slider").click(function() {
    let value = $('.handle-display').text();
    let term = $('#term_header').text();
    window.amplitude.rangeSliderCtaEvent(value, term);
  });
// event for homepage cta buttons with the amplitude-cta class
$(".amplitude-cta").click(function() {
    let section = $(this).closest("section").attr("class");
    let buttonText = $(this).text();
    let buttonUrl = window.location.href;
    let targetUrl = $(this).attr('href');
    let buttonColor = $(this).css('background-color');
    window.amplitude.buttonClickEvent(section, buttonText, buttonUrl, targetUrl, buttonColor);
});